
import UploadFloorPlanForm from '@/components/Management/Store/UploadFloorPlanForm';

export default {
  components: {
    UploadFloorPlanForm
  }
};
